import { roomSubjectApi, wechatApi } from '@/request/index';

class SubjectServer {
  constructor() {
    if (typeof SubjectServer.instance === 'object') {
      return SubjectServer.instance;
    }

    this.state = {
      subjectDetailInfo: {},
      subjectAuthInfo: {},
      webinarList: []
    };
  }

  // 获取专题详情信息
  getSubjectInfo(data = {}) {
    return roomSubjectApi.subject.getSubjectInfo(data).then(res => {
      if (res.code === 200) {
        // 基本信息
        this.state.subjectDetailInfo = res.data;
      }
      return res;
    });
  }

  // 获取专题详情信息
  getWebinarList(data = {}) {
    return roomSubjectApi.subject.getWebinarList(data).then(res => {
      if (res.code === 200) {
        // 基本信息
        this.state.webinarList = res.data.list
      }
      return res;
    });
  }

  wechatShare(data = {}) {
    return wechatApi.wechatShare(data);
  }

  wwchatShare(data = {}) {
    return wechatApi.wwchatShare(data);
  }
  wechatOaSdkSign(data = {}) {
    return wechatApi.wechatOaSdkSign(data);
  }

  // 专题鉴权
  getSubjectWatchAuth(data = {}) {
    return roomSubjectApi.subject.getSubjectWatchAuth(data);
  }

  //专题初始化
  initSubjectInfo(data = {}) {
    return roomSubjectApi.subject.initSubjectInfo(data).then(res => {
      if (res.code == 200) {
        // 权限
        this.state.subjectAuthInfo = res.data;
      }
      return res;
    })
  }

  //获取专题下已报名活动列表
  getRegWebinarList(data = {}) {
    return roomSubjectApi.subject.getRegWebinarList(data);
  }

  //获取当前用户报名的信息
  getAnswerInfo(data = {}) {
    return roomSubjectApi.subject.getAnswerInfo(data);
  }
}

export default function useSubjectServer() {
  if (!useSubjectServer.instance) {
    useSubjectServer.instance = new SubjectServer();
  }

  return useSubjectServer.instance;
}
